import React from "react";
import { Box } from "@mui/material";

const BaseFooter = ({}: {}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        maxWidth: "95vw",
      }}
    ></Box>
  );
};

export default BaseFooter;
